import { initNavPanels } from './modules/nav-panels.js';
import { initNavigation } from './modules/navigation.js';
import { initThemeToggling } from './modules/theme-toggling.js';
import { initCustomCursor } from './modules/custom-cursor.js';
import { initHeroAnimations, initScrollReveals } from './modules/hero-animations.js';
import { initScrollPolish } from './modules/scroll-nav-polish.js';
import { initCarousels } from './modules/carousel-system.js';
import { initTeamCardFlip } from './modules/team-card-flip.js';
import { initAccordion } from './modules/accordion.js';
import { initPollAnimation } from './modules/poll-bar-animation.js';
import { initThemeToggle } from './modules/material-design-3-main-theme-toggle.js';
import { initIAAThemeToggle } from './modules/iaa-alliance-theme-toggle.js';
import { initSearch } from './modules/search-functionality.js';
import { initNewsletterSpamProtection } from './modules/newsletter-spam-protection.js';
import { initAttribution } from './modules/attribution.js';

document.addEventListener('DOMContentLoaded', () => {
  // Before initNavigation — see the ORDER note in nav-panels.js.
  initNavPanels();
  initNavigation();
  initThemeToggling();
  initTeamCardFlip();
  initCarousels();
  initAccordion();
  initScrollPolish();
  initPollAnimation();
  initThemeToggle();
  initSearch();
  initIAAThemeToggle();
  initNewsletterSpamProtection();
  initAttribution();

  // GSAP is loaded by `base.njk` only on pages holding something it animates,
  // so absence here is the normal case on most of the site rather than a fault
  // — hence no warning. The guard stays: it is what makes the conditional load
  // safe, and it still covers a genuine cdnjs failure, which the browser logs
  // as a failed request of its own.
  if (typeof gsap !== 'undefined') {
    initCustomCursor();
    initHeroAnimations();
    initScrollReveals();
  }
});
